import React from 'react';
import TopWhatGamePC from './TopWhatGamePC';
import TopWhatGameSP from './TopWhatGameSP';

function TopWhatGame({ mobile }) {
  return mobile ? <TopWhatGameSP /> : <TopWhatGamePC />;
}

export default TopWhatGame;
